
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Github, LineChart, Mail } from 'lucide-react';
import { Separator } from './ui/separator';
const Footer = () => {
  const currentYear = new Date().getFullYear();
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  // Função para rolar para a seção, se estiver na página inicial
  const scrollToSection = (sectionId: string, e: React.MouseEvent) => {
    if (isHomePage) {
      e.preventDefault();
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  return <footer className="bg-blue-dark text-white mt-16">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="bg-white/20 p-1.5 rounded">
                <LineChart className="h-5 w-5" />
              </div>
              <span className="font-bold text-xl">BrokerBase</span>
            </div>
            <p className="text-white/80 mb-6 max-w-md">
              A plataforma de inteligência imobiliária que traz dados e análises precisas para investidores e compradores tomarem decisões inteligentes.
            </p>
            
          </div>

          <div className="col-span-1">
            <h3 className="font-semibold text-lg mb-4">Soluções</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/analisar-imovel" className="text-white/70 hover:text-white transition-colors" onClick={e => scrollToSection('analise', e)}>
                  Análise de Imóveis Automática
                </Link>
              </li>
              <li>
                <Link to="/home" className="text-white/70 hover:text-white transition-colors" onClick={e => scrollToSection('dashboard', e)}>
                  Dashboards de Mercado
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <Separator className="my-8 bg-white/10" />

        <div className="flex flex-col md:flex-row justify-between items-center">
          <p className="text-white/60 text-sm">
            &copy; {currentYear} BrokerBase. Todos os direitos reservados.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <Link to="/termos-de-uso" className="text-white/60 hover:text-white text-sm transition-colors">
              Termos de Uso
            </Link>
            <Link to="/politica-de-privacidade" className="text-white/60 hover:text-white text-sm transition-colors">
              Política de Privacidade
            </Link>
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;
